/* tslint:disable */
/* eslint-disable */
export enum EftersynStateEnum {
  NotCreated = 'NotCreated',
  Created = 'Created',
  Completed = 'Completed'
}
